// @router

import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
const HomePage = () => import(`../views/HomePage.vue`);

const neoAndWatsonReport = () =>
  import("@/components/report/neoAndWatsonReport.vue");
const examPackType3 = () => import("@/components/report/examPackType3.vue");
const helpPage = () => import("../views/helps/index.vue");

export const homeRoutes: RouteConfig[] = [
  {
    path: "/",
    name: "dynamic_home",
    meta: {
      requiresAuth: true,
    },
    redirect: "/home",
    component: newContainer,
    children: [
      {
        path: "home",
        name: "dynamic_home",
        meta: {
          requiresAuth: true,
        },
        component: HomePage,
      },
      {
        path: "dashboard",
        name: "dashboard",
        meta: {
          label: "خانه",
          requiresAuth: true,
          deprecated: true,
        },
        component: HomePage,
      },
      {
        path: "recorded-voice",
        name: "recorded-voice",
        meta: {
          label: "صوت های ضبط شده",
          requiresAuth: true,
          deprecated: true,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack1/:examPackId/:resourceCode?",
        name: "exam_pack_type_1-report",
        component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack2/:examPackId/:resourceCode?",
        name: "exam_pack_type_2-report",
        component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPack3/:examPackId/:resourceCode?",
        name: "exam_pack_type_3-report",
        component: neoAndWatsonReport,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
        },
      },
      {
        path: "reports/parvandeh/:parvandehCode/examPackInterview/:examPackId/:resourceCode?",
        name: "exam_pack_interview-report",
        component: examPackType3,
        meta: {
          label: "گزارش آزمون",
          requiresAuth: true,
        },
      },
      {
        name: "help",
        path: "help",
        component: {
          render(c: any) {
            return c("router-view");
          },
        },
        redirect: "/help/research",
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            name: "research_help",
            path: "research",
            component: helpPage,
            meta: {
              label: "راهنمای تحقیق",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            name: "interview_help",
            path: "interview",
            component: helpPage,
            meta: {
              label: "راهنمای مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            name: "kanoon_help",
            path: "kanoon",
            component: helpPage,
            meta: {
              label: "راهنمای کانون",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            name: "assessor_help",
            path: "assessor",
            component: helpPage,
            meta: {
              label: "راهنمای ارزیاب",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            name: "primary_agent_help",
            path: "primary-agent",
            component: helpPage,
            meta: {
              label: "راهنمای نماینده معاونت ابتدایی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            name: "administrative_agent_help",
            path: "administrative-agent",
            component: helpPage,
            meta: {
              label: "راهنمای نماینده امور اداری",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "log-activities",
        name: "log_activities",
        redirect: "/log-activities/list",
        meta: {
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "log-activities-list",
            meta: {
              label: "تاریخچه تغییرات داده",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "system-configuration",
        name: "system_config",
        redirect: "/system-configuration/configs",
        meta: {
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "configs",
            name: "system-config-configs",
            meta: {
              label: "تنظیمات",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "form-builder",
        name: "form_builder",
        redirect: "/form-builder/list",
        meta: {
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "form-builder-list",
            meta: {
              label: "لیست فرم های راهنما",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "create",
            name: "form-builder-create",
            meta: {
              label: "فرم جدید",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/update",
            name: "form-builder-update",
            meta: {
              label: "فرم ویرایش",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/view",
            name: "form-builder-view",
            meta: {
              label: "نمایش فرم",
              requiresAuth: true,
              deprecated: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
    ],
  },
];
